import { ReactElement } from 'react';
import VerticalLine from '@src/sld/components/Line/VerticalLine';
import Unit from './Unit';
import HorizontalLine from '@src/sld/components/Line/HorizontalLine';
import { UnitController, UnitControllerSN } from '../devicePointsConfig';
import { getDataPointsForUnitController } from '@src/sld/utils';

type D_UnitsProps = {
  unitControllersWithDataPointValues: UnitController[];
};

function D_Units(props: D_UnitsProps): ReactElement {
  const { unitControllersWithDataPointValues } = props;

  return (
    <>
      <HorizontalLine
        translateXCoordinate={330}
        translateYCoordinate={175}
        length={485}
        color='white'
        width={0.5}
      />

      <VerticalLine
        translateXCoordinate={815}
        translateYCoordinate={10}
        length={165}
        color='white'
        width={0.5}
      />

      <VerticalLine
        translateXCoordinate={330}
        translateYCoordinate={175}
        length={25}
        color='white'
        width={0.5}
      />
      <Unit
        label={'F2D1'}
        dataPoints={getDataPointsForUnitController(
          unitControllersWithDataPointValues,
          UnitControllerSN.F2_D1,
        )}
        rectangleXCoordinate='295'
        rectangleYCoordinate='200'
        textStartingXCoordinate={300}
        textStartingYCoordinate={198}
        lineTransformXCoordinate={235}
        lineTransformYCoordinate={175}
        skipHorizontalLine
      />

      <VerticalLine
        translateXCoordinate={425}
        translateYCoordinate={175}
        length={25}
        color='white'
        width={0.5}
      />
      <Unit
        label={'F2D2'}
        dataPoints={getDataPointsForUnitController(
          unitControllersWithDataPointValues,
          UnitControllerSN.F2_D2,
        )}
        rectangleXCoordinate='385'
        rectangleYCoordinate='200'
        textStartingXCoordinate={390}
        textStartingYCoordinate={198}
        lineTransformXCoordinate={235}
        lineTransformYCoordinate={175}
        skipHorizontalLine
      />

      <VerticalLine
        translateXCoordinate={515}
        translateYCoordinate={175}
        length={25}
        color='white'
        width={0.5}
      />
      <Unit
        label={'F2D3'}
        dataPoints={getDataPointsForUnitController(
          unitControllersWithDataPointValues,
          UnitControllerSN.F2_D3,
        )}
        rectangleXCoordinate='475'
        rectangleYCoordinate='200'
        textStartingXCoordinate={480}
        textStartingYCoordinate={198}
        lineTransformXCoordinate={235}
        lineTransformYCoordinate={175}
        skipHorizontalLine
      />

      <VerticalLine
        translateXCoordinate={605}
        translateYCoordinate={175}
        length={25}
        color='white'
        width={0.5}
      />

      <Unit
        label={'F2D4'}
        dataPoints={getDataPointsForUnitController(
          unitControllersWithDataPointValues,
          UnitControllerSN.F2_D4,
        )}
        rectangleXCoordinate='565'
        rectangleYCoordinate='200'
        textStartingXCoordinate={570}
        textStartingYCoordinate={198}
        lineTransformXCoordinate={235}
        lineTransformYCoordinate={175}
        skipHorizontalLine
      />

      <VerticalLine
        translateXCoordinate={695}
        translateYCoordinate={175}
        length={25}
        color='white'
        width={0.5}
      />
      <Unit
        label={'F2D5'}
        dataPoints={getDataPointsForUnitController(
          unitControllersWithDataPointValues,
          UnitControllerSN.F2_D5,
        )}
        rectangleXCoordinate='655'
        rectangleYCoordinate='200'
        textStartingXCoordinate={660}
        textStartingYCoordinate={198}
        lineTransformXCoordinate={235}
        lineTransformYCoordinate={175}
        skipHorizontalLine
      />

      <VerticalLine
        translateXCoordinate={785}
        translateYCoordinate={175}
        length={25}
        color='white'
        width={0.5}
      />
      <Unit
        label={'F2D6'}
        dataPoints={getDataPointsForUnitController(
          unitControllersWithDataPointValues,
          UnitControllerSN.F2_D6,
        )}
        rectangleXCoordinate='745'
        rectangleYCoordinate='200'
        textStartingXCoordinate={750}
        textStartingYCoordinate={198}
        lineTransformXCoordinate={235}
        lineTransformYCoordinate={175}
        skipHorizontalLine
      />
    </>
  );
}

export default D_Units;
